module.exports = __webpack_public_path__ + "static/media/DejaVu-sdf.414c57e4.fnt";